import SideNavbar from "../externals/SideNavbar";
import OverviewTable from "../externals/OverviewTable";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import axios from "axios";


function Overview(props){

    const authMap = {
        "Samir Ilie-Rusu" : "*",
        "Andrei Stefan" : "*",
        "Octavia Codru" : "*",
        "Cosmin Codru" : "*",
        "Dan Dimitrescu" : "*",
        "Edy Franke" : "open_teams,open_tm,etapa4",
        "Andrei Stoica" : "etapa1,winter_cup",
        "Sebastian Cosma" : "*",
        "Calin Baciu" : "etapa6",
        "Mihai Albu" : "ro_cup,etapa2,etapa8",
        "Alexandru Guriuc":"etapa8",
        "zolimar":"etapa9,etapa3",
        "Radu Costache":"etapa6",
        "Roxana Pirvulescu":"fanarm_cup"
    }

    var user = window.localStorage.getItem("uName");
    var userNtk = window.localStorage.getItem("userNtk");
    var isAuth = authMap[user];
    const navigate = useNavigate();
    const [toggle, setToggle] = useState(false)

    function checkRights()
    {
        let auth = false;

        if(String(isAuth).includes(props.stage) === true)
            auth = true

        return auth;
    }
    
    useEffect(() => {

    axios.post("https://nodeppcbackend-production.up.railway.app/api/allowAccess", {
      Username: user.toString(),
      Signature: userNtk.toString(),
    })
    .then((response) => {
      if (response.data["Access"] === true) {

        if (isAuth !== "*" && checkRights() !== true) {
          alert("Nu aveti drepturi pentru a accesa aceasta etapa!");
          navigate("/Admin/Dashboard");
        }
      } 
      else 
      {
        //alert("Trebuie sa va logati din nou!");
        navigate("/Admin");
      }
    })
    .catch((err) => {

    });
   });


    if((isAuth === "*") || (checkRights() === true)){
        return(
            <div>
                <div className="row">
                    <div className='col'>
                        <SideNavbar username={user}/>
                    </div>
                    <div className='col-6'>
                        <OverviewTable stage = {props.stage} />
                    </div>
                </div>
            </div>
        );
    }
    
    

}



export default Overview;